"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferConflictException = exports.InvalidResponseException = exports.TaskAlreadyExistsException = exports.ResourceRegistrationFailureException = exports.CertificateConflictException = exports.RegistrationCodeValidationException = exports.NotConfiguredException = exports.CertificateStateException = exports.DeleteConflictException = exports.SqlParseException = exports.VersionsLimitExceededException = exports.MalformedPolicyException = exports.InvalidAggregationException = exports.IndexNotReadyException = exports.InvalidQueryException = exports.CertificateValidationException = exports.ResourceAlreadyExistsException = exports.InternalException = exports.ConflictingResourceUpdateException = exports.InvalidStateTransitionException = exports.VersionConflictException = exports.LimitExceededException = exports.ValidationException = exports.ServiceQuotaExceededException = exports.InternalServerException = exports.ConflictException = exports.UnauthorizedException = exports.TransferAlreadyCompletedException = exports.ThrottlingException = exports.ServiceUnavailableException = exports.ResourceNotFoundException = exports.InvalidRequestException = exports.InternalFailureException = void 0;
const IoTServiceException_1 = require("./IoTServiceException");
class InternalFailureException extends IoTServiceException_1.IoTServiceException {
    name = "InternalFailureException";
    $fault = "server";
    constructor(opts) {
        super({
            name: "InternalFailureException",
            $fault: "server",
            ...opts,
        });
        Object.setPrototypeOf(this, InternalFailureException.prototype);
    }
}
exports.InternalFailureException = InternalFailureException;
class InvalidRequestException extends IoTServiceException_1.IoTServiceException {
    name = "InvalidRequestException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidRequestException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidRequestException.prototype);
    }
}
exports.InvalidRequestException = InvalidRequestException;
class ResourceNotFoundException extends IoTServiceException_1.IoTServiceException {
    name = "ResourceNotFoundException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "ResourceNotFoundException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ResourceNotFoundException.prototype);
    }
}
exports.ResourceNotFoundException = ResourceNotFoundException;
class ServiceUnavailableException extends IoTServiceException_1.IoTServiceException {
    name = "ServiceUnavailableException";
    $fault = "server";
    constructor(opts) {
        super({
            name: "ServiceUnavailableException",
            $fault: "server",
            ...opts,
        });
        Object.setPrototypeOf(this, ServiceUnavailableException.prototype);
    }
}
exports.ServiceUnavailableException = ServiceUnavailableException;
class ThrottlingException extends IoTServiceException_1.IoTServiceException {
    name = "ThrottlingException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "ThrottlingException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ThrottlingException.prototype);
    }
}
exports.ThrottlingException = ThrottlingException;
class TransferAlreadyCompletedException extends IoTServiceException_1.IoTServiceException {
    name = "TransferAlreadyCompletedException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "TransferAlreadyCompletedException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, TransferAlreadyCompletedException.prototype);
    }
}
exports.TransferAlreadyCompletedException = TransferAlreadyCompletedException;
class UnauthorizedException extends IoTServiceException_1.IoTServiceException {
    name = "UnauthorizedException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "UnauthorizedException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, UnauthorizedException.prototype);
    }
}
exports.UnauthorizedException = UnauthorizedException;
class ConflictException extends IoTServiceException_1.IoTServiceException {
    name = "ConflictException";
    $fault = "client";
    resourceId;
    constructor(opts) {
        super({
            name: "ConflictException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ConflictException.prototype);
        this.resourceId = opts.resourceId;
    }
}
exports.ConflictException = ConflictException;
class InternalServerException extends IoTServiceException_1.IoTServiceException {
    name = "InternalServerException";
    $fault = "server";
    constructor(opts) {
        super({
            name: "InternalServerException",
            $fault: "server",
            ...opts,
        });
        Object.setPrototypeOf(this, InternalServerException.prototype);
    }
}
exports.InternalServerException = InternalServerException;
class ServiceQuotaExceededException extends IoTServiceException_1.IoTServiceException {
    name = "ServiceQuotaExceededException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "ServiceQuotaExceededException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ServiceQuotaExceededException.prototype);
    }
}
exports.ServiceQuotaExceededException = ServiceQuotaExceededException;
class ValidationException extends IoTServiceException_1.IoTServiceException {
    name = "ValidationException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "ValidationException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ValidationException.prototype);
    }
}
exports.ValidationException = ValidationException;
class LimitExceededException extends IoTServiceException_1.IoTServiceException {
    name = "LimitExceededException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "LimitExceededException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, LimitExceededException.prototype);
    }
}
exports.LimitExceededException = LimitExceededException;
class VersionConflictException extends IoTServiceException_1.IoTServiceException {
    name = "VersionConflictException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "VersionConflictException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, VersionConflictException.prototype);
    }
}
exports.VersionConflictException = VersionConflictException;
class InvalidStateTransitionException extends IoTServiceException_1.IoTServiceException {
    name = "InvalidStateTransitionException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidStateTransitionException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidStateTransitionException.prototype);
    }
}
exports.InvalidStateTransitionException = InvalidStateTransitionException;
class ConflictingResourceUpdateException extends IoTServiceException_1.IoTServiceException {
    name = "ConflictingResourceUpdateException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "ConflictingResourceUpdateException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ConflictingResourceUpdateException.prototype);
    }
}
exports.ConflictingResourceUpdateException = ConflictingResourceUpdateException;
class InternalException extends IoTServiceException_1.IoTServiceException {
    name = "InternalException";
    $fault = "server";
    constructor(opts) {
        super({
            name: "InternalException",
            $fault: "server",
            ...opts,
        });
        Object.setPrototypeOf(this, InternalException.prototype);
    }
}
exports.InternalException = InternalException;
class ResourceAlreadyExistsException extends IoTServiceException_1.IoTServiceException {
    name = "ResourceAlreadyExistsException";
    $fault = "client";
    resourceId;
    resourceArn;
    constructor(opts) {
        super({
            name: "ResourceAlreadyExistsException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ResourceAlreadyExistsException.prototype);
        this.resourceId = opts.resourceId;
        this.resourceArn = opts.resourceArn;
    }
}
exports.ResourceAlreadyExistsException = ResourceAlreadyExistsException;
class CertificateValidationException extends IoTServiceException_1.IoTServiceException {
    name = "CertificateValidationException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "CertificateValidationException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, CertificateValidationException.prototype);
    }
}
exports.CertificateValidationException = CertificateValidationException;
class InvalidQueryException extends IoTServiceException_1.IoTServiceException {
    name = "InvalidQueryException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidQueryException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidQueryException.prototype);
    }
}
exports.InvalidQueryException = InvalidQueryException;
class IndexNotReadyException extends IoTServiceException_1.IoTServiceException {
    name = "IndexNotReadyException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "IndexNotReadyException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, IndexNotReadyException.prototype);
    }
}
exports.IndexNotReadyException = IndexNotReadyException;
class InvalidAggregationException extends IoTServiceException_1.IoTServiceException {
    name = "InvalidAggregationException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidAggregationException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidAggregationException.prototype);
    }
}
exports.InvalidAggregationException = InvalidAggregationException;
class MalformedPolicyException extends IoTServiceException_1.IoTServiceException {
    name = "MalformedPolicyException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "MalformedPolicyException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, MalformedPolicyException.prototype);
    }
}
exports.MalformedPolicyException = MalformedPolicyException;
class VersionsLimitExceededException extends IoTServiceException_1.IoTServiceException {
    name = "VersionsLimitExceededException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "VersionsLimitExceededException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, VersionsLimitExceededException.prototype);
    }
}
exports.VersionsLimitExceededException = VersionsLimitExceededException;
class SqlParseException extends IoTServiceException_1.IoTServiceException {
    name = "SqlParseException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "SqlParseException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, SqlParseException.prototype);
    }
}
exports.SqlParseException = SqlParseException;
class DeleteConflictException extends IoTServiceException_1.IoTServiceException {
    name = "DeleteConflictException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "DeleteConflictException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, DeleteConflictException.prototype);
    }
}
exports.DeleteConflictException = DeleteConflictException;
class CertificateStateException extends IoTServiceException_1.IoTServiceException {
    name = "CertificateStateException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "CertificateStateException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, CertificateStateException.prototype);
    }
}
exports.CertificateStateException = CertificateStateException;
class NotConfiguredException extends IoTServiceException_1.IoTServiceException {
    name = "NotConfiguredException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "NotConfiguredException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, NotConfiguredException.prototype);
    }
}
exports.NotConfiguredException = NotConfiguredException;
class RegistrationCodeValidationException extends IoTServiceException_1.IoTServiceException {
    name = "RegistrationCodeValidationException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "RegistrationCodeValidationException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, RegistrationCodeValidationException.prototype);
    }
}
exports.RegistrationCodeValidationException = RegistrationCodeValidationException;
class CertificateConflictException extends IoTServiceException_1.IoTServiceException {
    name = "CertificateConflictException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "CertificateConflictException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, CertificateConflictException.prototype);
    }
}
exports.CertificateConflictException = CertificateConflictException;
class ResourceRegistrationFailureException extends IoTServiceException_1.IoTServiceException {
    name = "ResourceRegistrationFailureException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "ResourceRegistrationFailureException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ResourceRegistrationFailureException.prototype);
    }
}
exports.ResourceRegistrationFailureException = ResourceRegistrationFailureException;
class TaskAlreadyExistsException extends IoTServiceException_1.IoTServiceException {
    name = "TaskAlreadyExistsException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "TaskAlreadyExistsException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, TaskAlreadyExistsException.prototype);
    }
}
exports.TaskAlreadyExistsException = TaskAlreadyExistsException;
class InvalidResponseException extends IoTServiceException_1.IoTServiceException {
    name = "InvalidResponseException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "InvalidResponseException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, InvalidResponseException.prototype);
    }
}
exports.InvalidResponseException = InvalidResponseException;
class TransferConflictException extends IoTServiceException_1.IoTServiceException {
    name = "TransferConflictException";
    $fault = "client";
    constructor(opts) {
        super({
            name: "TransferConflictException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, TransferConflictException.prototype);
    }
}
exports.TransferConflictException = TransferConflictException;
